import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchPatientsForLinkingQueryVariables = Types.Exact<{
  patient: Types.SearchPatientInput;
  isFuzzySearch?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type SearchPatientsForLinkingQuery = { readonly __typename?: 'Query', readonly searchPatients?: ReadonlyArray<{ readonly __typename?: 'Patient', readonly uuid: string, readonly card?: { readonly __typename?: 'PatientCard', readonly id?: string | null } | null, readonly person: { readonly __typename?: 'Person', readonly contactPoints: ReadonlyArray<{ readonly __typename?: 'ContactPoint', readonly system: Types.ContactPointSystem, readonly value: string } | null>, readonly name: { readonly __typename?: 'Name', readonly fullname?: string | null }, readonly addresses: ReadonlyArray<{ readonly __typename?: 'Address', readonly country?: string | null, readonly state?: string | null, readonly street?: string | null, readonly subCounty?: string | null, readonly ward?: string | null } | null> } } | null> | null };

export type SearchPatientsForRegistrationQueryVariables = Types.Exact<{
  patient: Types.SearchPatientInput;
}>;


export type SearchPatientsForRegistrationQuery = { readonly __typename?: 'Query', readonly searchPatients?: ReadonlyArray<{ readonly __typename?: 'Patient', readonly uuid: string, readonly person: { readonly __typename?: 'Person', readonly dob: string, readonly nationalIdNumber?: string | null, readonly name: { readonly __typename?: 'Name', readonly firstname?: string | null, readonly middlename?: string | null, readonly lastname?: string | null }, readonly contactPoints: ReadonlyArray<{ readonly __typename?: 'ContactPoint', readonly system: Types.ContactPointSystem, readonly value: string } | null>, readonly addresses: ReadonlyArray<{ readonly __typename?: 'Address', readonly street?: string | null } | null> } } | null> | null };


export const SearchPatientsForLinkingDocument = gql`
    query SearchPatientsForLinking($patient: SearchPatientInput!, $isFuzzySearch: Boolean) {
  searchPatients(patient: $patient, isFuzzySearch: $isFuzzySearch) {
    uuid
    card {
      id
    }
    person {
      contactPoints {
        system
        value
      }
      name {
        fullname
      }
      addresses {
        country
        state
        street
        subCounty
        ward
      }
    }
  }
}
    `;

/**
 * __useSearchPatientsForLinkingQuery__
 *
 * To run a query within a React component, call `useSearchPatientsForLinkingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPatientsForLinkingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPatientsForLinkingQuery({
 *   variables: {
 *      patient: // value for 'patient'
 *      isFuzzySearch: // value for 'isFuzzySearch'
 *   },
 * });
 */
export function useSearchPatientsForLinkingQuery(baseOptions: Apollo.QueryHookOptions<SearchPatientsForLinkingQuery, SearchPatientsForLinkingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPatientsForLinkingQuery, SearchPatientsForLinkingQueryVariables>(SearchPatientsForLinkingDocument, options);
      }
export function useSearchPatientsForLinkingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPatientsForLinkingQuery, SearchPatientsForLinkingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPatientsForLinkingQuery, SearchPatientsForLinkingQueryVariables>(SearchPatientsForLinkingDocument, options);
        }
export type SearchPatientsForLinkingQueryHookResult = ReturnType<typeof useSearchPatientsForLinkingQuery>;
export type SearchPatientsForLinkingLazyQueryHookResult = ReturnType<typeof useSearchPatientsForLinkingLazyQuery>;
export type SearchPatientsForLinkingQueryResult = Apollo.QueryResult<SearchPatientsForLinkingQuery, SearchPatientsForLinkingQueryVariables>;
export const SearchPatientsForRegistrationDocument = gql`
    query SearchPatientsForRegistration($patient: SearchPatientInput!) {
  searchPatients(patient: $patient) {
    uuid
    person {
      dob
      name {
        firstname
        middlename
        lastname
      }
      contactPoints {
        system
        value
      }
      addresses {
        street
      }
      nationalIdNumber
    }
  }
}
    `;

/**
 * __useSearchPatientsForRegistrationQuery__
 *
 * To run a query within a React component, call `useSearchPatientsForRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPatientsForRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPatientsForRegistrationQuery({
 *   variables: {
 *      patient: // value for 'patient'
 *   },
 * });
 */
export function useSearchPatientsForRegistrationQuery(baseOptions: Apollo.QueryHookOptions<SearchPatientsForRegistrationQuery, SearchPatientsForRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPatientsForRegistrationQuery, SearchPatientsForRegistrationQueryVariables>(SearchPatientsForRegistrationDocument, options);
      }
export function useSearchPatientsForRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPatientsForRegistrationQuery, SearchPatientsForRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPatientsForRegistrationQuery, SearchPatientsForRegistrationQueryVariables>(SearchPatientsForRegistrationDocument, options);
        }
export type SearchPatientsForRegistrationQueryHookResult = ReturnType<typeof useSearchPatientsForRegistrationQuery>;
export type SearchPatientsForRegistrationLazyQueryHookResult = ReturnType<typeof useSearchPatientsForRegistrationLazyQuery>;
export type SearchPatientsForRegistrationQueryResult = Apollo.QueryResult<SearchPatientsForRegistrationQuery, SearchPatientsForRegistrationQueryVariables>;